import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Camera, Sparkles, Menu, X } from 'lucide-react';
export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Features',
    href: '#features'
  }, {
    name: 'Photobooth',
    href: '#photobooth'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 glass-card mx-4 mt-4 rounded-full px-6 py-3 flex items-center justify-between" data-id="element-78">
      <a href="#home" className="flex items-center gap-2 group" data-id="element-79">
        <span className="font-pacifico text-2xl text-gradient-pink group-hover:scale-105 transition-transform" data-id="element-80">
          SnapMory
        </span>
        <Sparkles className="w-5 h-5 text-pink-400 animate-pulse-slow" data-id="element-81" />
      </a>

      <div className="hidden md:flex items-center gap-8 font-quicksand font-medium text-pink-800" data-id="element-82">
        {navLinks.map(link => <a key={link.name} href={link.href} className="hover:text-pink-500 transition-colors relative after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-0 after:h-0.5 after:bg-pink-400 hover:after:w-full after:transition-all after:duration-300" data-id="element-83">
            {link.name}
          </a>)}
      </div>

      <a href="#photobooth" className="hidden md:flex items-center gap-2 bg-gradient-pink text-white px-5 py-2 rounded-full font-medium hover:scale-105 hover:shadow-[0_0_15px_rgba(255,105,180,0.5)] transition-all duration-300" data-id="element-84">
        <Camera className="w-4 h-4" data-id="element-85" />
        <span data-id="element-86">Take Photo</span>
      </a>

      <button className="md:hidden text-pink-600" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle navigation menu" data-id="element-87">
        {isOpen ? <X data-id="element-88" /> : <Menu data-id="element-89" />}
      </button>

      <AnimatePresence data-id="element-90">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 mt-2 glass-card rounded-3xl p-4 flex flex-col gap-4 md:hidden" data-id="element-91">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="text-center font-quicksand font-medium text-pink-800 hover:text-pink-500 py-2" data-id="element-92">
                {link.name}
              </a>)}
          </motion.div>}
      </AnimatePresence>
    </nav>;
};